<script setup lang="ts">
/**
 * Form 45B — Consent to Act as Secretary (Companies Act)
 * 패키지에서 DocScope 로 N부 반복.
 */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head" style="text-align:center">
      <div class="doc-meta">THE COMPANIES ACT 1967</div>
      <div class="doc-lbl-title" style="margin-top:10px">CONSENT TO ACT AS SECRETARY</div>
      <div class="doc-company" style="margin-top:8px; letter-spacing:.2em">FORM 45B</div>
    </div>

    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Name of Company</td>
          <td><CddVarField field-key="company_name" label="Company Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Company No</td>
          <td><CddVarField field-key="company_registration_no" label="Company Registration No." /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-p" style="margin-top:12px">
      I, the undermentioned person, hereby consent to act as a secretary of the abovenamed company with effect from
      <CddVarField field-key="appointment_effective_date" label="Appointment Effective Date" />.
    </p>

    <p class="doc-sec-title">Particulars of Secretary</p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Name</td>
          <td><CddVarField field-key="secretary_name" label="Secretary Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Identification No.</td>
          <td><CddVarField field-key="secretary_identification_no" label="Secretary Identification No." /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Nationality</td>
          <td><CddVarField field-key="secretary_nationality" label="Secretary Nationality" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Address</td>
          <td><CddVarField field-key="secretary_address" label="Secretary Address" /></td>
        </tr>
      </tbody>
    </table>

    <p class="doc-sec-title">Execution</p>
    <p class="doc-p">
      Date:
      <CddVarField field-key="execution_date" label="Execution Date" />
    </p>
    <div class="sig-block">
      <div class="sig-line">________________________________________________</div>
      <div class="sig-role">Signature of Secretary</div>
      <div class="doc-p"><b>Name:</b> <CddVarField field-key="secretary_name" label="Secretary Name" /></div>
    </div>
  </div>
</template>
